import React from "react";
import { Circle, Path } from "react-konva";

export function AvatarMissingIcon() {
  return (
    <>
      <Circle x={12} y={12} radius={11.5} fill="white" stroke="#AFB3BF" strokeWidth={1.2} />
      <Path
        data="M7.7644 9.88251C7.7644 11.0058 8.21062 12.083 9.00489 12.8773C9.79916 13.6716 10.8764 14.1178 11.9997 14.1178C13.123 14.1178 14.2002 13.6716 14.9945 12.8773C15.7888 12.083 16.235 11.0058 16.235 9.88251C16.235 8.75924 15.7888 7.68198 14.9945 6.88771C14.2002 6.09343 13.123 5.64722 11.9997 5.64722C10.8764 5.64722 9.79916 6.09343 9.00489 6.88771C8.21062 7.68198 7.7644 8.75924 7.7644 9.88251Z"
        stroke="#AFB3BF"
        strokeWidth={1.2}
        lineCap="round"
        lineJoin="round"
      />
      <Path
        data="M5.64697 21.3179C5.64697 20.1947 6.09319 19.1174 6.88746 18.3231C7.68173 17.5289 8.759 17.0826 9.88227 17.0826H14.1176C15.2408 17.0826 16.3181 17.5289 17.1124 18.3231C17.9066 19.1174 18.3529 20.1947 18.3529 21.3179"
        stroke="#AFB3BF"
        strokeWidth={1.2}
        lineCap="round"
        lineJoin="round"
      />
    </>
  );
}
